import React, { useState } from 'react'

import { Flex } from 'lese'
import { H1 } from 'Components/shared/Typography'
import { Button } from 'Components/shared/Button'

import { ModalCard, closeModal } from 'components/Modal'
import Container, { Row } from 'Components/shared/Container'
import cloneClient from 'Helpers/clone'
import { setSelection } from 'Store/clubs'
import { toast } from 'react-toastify'

import styled from '@emotion/styled'
import Select from 'react-select'

const ClientSelectMenu = styled(Select)`
  width: 400px;
`

const CloneClientModal = ({
  options,
  clubs,
  onCancel = closeModal,
  setSelectedClub,
  setSelected,
  setMaster,
  setCustomLinks
}) => {
  const [clubId, setClubId] = useState()

  const onClubChangeClick = async clubName => {
    let foundClub = clubs.filter(club => {
      return decodeURI(club.clubname) === clubName
    })

    if (foundClub.length === 0) {
      return toast.error('Club was not found.')
    }

    // Fancy array deconstruction, foundClub[0]
    ;[foundClub] = foundClub

    setClubId(foundClub.id)
  }

  return (
    <ModalCard>
      <H1 xAlign>Clone New Client</H1>
      <Flex separation="24px" padding="2em">
        <Container>
          <Row>
            <ClientSelectMenu
              options={options}
              onChange={obj => {
                const { value } = obj
                onClubChangeClick(value)
              }}
            />
          </Row>
          <Row style={{ paddingTop: '2em' }}>
            <Button
              style={{ margin: '1em' }}
              onClick={async () => {
                const { club, customLinks } = await cloneClient(clubId, setSelectedClub)
                if (typeof club !== 'object') return
                setSelection({ club: { ...club, cloned: true, alreadyCreated: false } })
                setSelectedClub({ ...club, cloned: true, alreadyCreated: false })
                setMaster({ ...club, cloned: true, alreadyCreated: false })
                setSelected(true)
                setCustomLinks(customLinks)
                onCancel()
              }}
            >
              Clone
            </Button>
          </Row>
        </Container>
      </Flex>
    </ModalCard>
  )
}
export default CloneClientModal
